import { registerSW } from "virtual:pwa-register";
import { createApp, markRaw } from "vue";

import App from "./App.vue";

import "./assets/main.scss";
// bootstrap
import * as bv3 from "bootstrap-vue-next";
// notification
import Notifications from "@kyvg/vue3-notification";
// pinia
import { createPinia } from "pinia";
import { PiniaLogger } from "pinia-logger";
// router
import router from "./router";
import type { Router } from "vue-router";
// components
import SiteHeader from "@/components/SiteHeader.vue";
import TabellaArticoli from "@/components/TabellaArticoli.vue";
import TableCell from "@/components/TableCell.vue";
import SiteHeaderTitle from "@/components/SiteHeaderTitle.vue";
import SiteOverlay from "@/components/SiteOverlay.vue";
// sentry
import * as Sentry from "@sentry/vue";

const updateSW = registerSW({
  async onNeedRefresh() {
    console.log("[main.ts] - registerSW - update now");
    try {
      await updateSW();
    } catch {
      location.reload();
    }
  },
});

const app = createApp(App);

import "bootstrap-icons/font/bootstrap-icons.css";
import { loadConfigs } from "@/utils";


app.use(bv3.createBootstrap());
app.use(Notifications);

const pinia = createPinia();
pinia.use(
  PiniaLogger({
    expanded: true,
    disabled: import.meta.env.PROD,
  })
);
app.use(pinia);

pinia.use(({ store }) => {
  store.$router = markRaw(router);
});
declare module "pinia" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export interface PiniaCustomProperties<Id, S, G, A> {
    $router: Router;
  }
}
app.use(router);

app.component("TableCell", TableCell);
app.component("TabellaArticoli", TabellaArticoli);
app.component("SiteHeader", SiteHeader);
app.component("SiteHeaderTitle", SiteHeaderTitle);
app.component("SiteOverlay", SiteOverlay);

app.directive("selectOnFocus", {
  mounted(el: HTMLElement) {
    el.addEventListener("focus", (e) => {
      (e.currentTarget as HTMLInputElement | null)?.select();
    });
  },
});

// keep configuration updated
(async function updateConfig() {
  const responses = await loadConfigs();
  const config = responses[0].data;
  if (config?.sentry?.dsn) {
    localStorage.setItem("SENTRY_DSN", config.sentry.dsn);
  } else {
    localStorage.removeItem("SENTRY_DSN");
  }
  if (config?.sentry?.environment) {
    localStorage.setItem("SENTRY_ENVIRONMENT", config.sentry.environment);
  } else {
    localStorage.setItem("SENTRY_ENVIRONMENT", import.meta.env.MODE);
  }
})();


// <sentry>
// se è stata caricata una configurazione, inizializza sentry con i dati della configurazione
// al primo caricamento non verrà caricato anche se è presente nella configurazione
const SENTRY_DSN = localStorage.getItem("SENTRY_DSN");
const SENTRY_ENVIRONMENT = localStorage.getItem("SENTRY_ENVIRONMENT");
if (SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        networkDetailAllowUrls: [window.location.origin],
        // blockAllMedia: false, // too expensive ?
      }),
      Sentry.replayCanvasIntegration(),
      Sentry.browserProfilingIntegration(),
    ],
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    //tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    tracePropagationTargets: [/.*/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    profilesSampleRate: 1.0,

  });
}
// </sentry>

app.mount("#app");
